// extracted by css-extract-rspack-plugin
export default {"form":"form-LtdMWD","dateInput":"dateInput-DsH6FW"};